import apiClient from './apiClient';

export const getDesignations = async (filters = {}) => {
    try {
        const queryParams = new URLSearchParams();
        Object.keys(filters).forEach((key) => {
            if (filters[key] !== undefined && filters[key] !== '') {
                queryParams.append(key, filters[key]);
            }
        });

        const response = await apiClient.get(`/designations?${queryParams.toString()}`, { skipGlobalError: true });
        // Handle various response structures for robustness
        const serverData = response.data.data || response.data.rows || response.data;
        const designationsArray = Array.isArray(serverData) ? serverData : (serverData?.rows || []);

        return {
            success: true,
            data: designationsArray,
            message: 'Designations fetched successfully'
        };
    } catch (error) {
        console.error('Error fetching designations:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Failed to fetch designations',
            error: error.message,
            data: []
        };
    }
};

export const createDesignation = async (data) => {
    try {
        const response = await apiClient.post('/designations', data, { skipGlobalError: true });
        return {
            success: true,
            data: response.data,
            message: 'Designation created successfully'
        };
    } catch (error) {
        console.error('Error creating designation:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Failed to create designation',
            error: error.message
        };
    }
};

export const updateDesignation = async (id, data) => {
    try {
        const response = await apiClient.put(`/designations/${id}`, data, { skipGlobalError: true });
        return {
            success: true,
            data: response.data,
            message: 'Designation updated successfully'
        };
    } catch (error) {
        console.error('Error updating designation:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Failed to update designation',
            error: error.message
        };
    }
};

export const deleteDesignation = async (id) => {
    try {
        const response = await apiClient.delete(`/designations/${id}`, { skipGlobalError: true });
        return {
            success: true,
            data: response.data,
            message: 'Designation deleted successfully'
        };
    } catch (error) {
        console.error('Error deleting designation:', error);
        return {
            success: false,
            message: error.response?.data?.message || 'Failed to delete designation',
            error: error.message
        };
    }
};

export const bulkUploadDesignations = async (formData) => {
    try {
        const response = await apiClient.post('/designations/bulk-upload', formData, { 
            headers: { 'Content-Type': 'multipart/form-data' },
            skipGlobalError: true 
        });
        return { success: true, data: response.data, message: response.data.message || 'Designations uploaded successfully' };
    } catch (error) {
        console.error('Error uploading designations:', error);
        return { success: false, message: error.response?.data?.message || 'Failed to upload designations', error: error.message };
    }
};
